// types
import { SelectedFieldProps, SelectType } from './types';

// components
import FilterTag from '../tags/filter';

import styles from './select.module.css';

export default function SelectedValue({
  selectValues,
  mode,
  list,
  size,
  removeItem,
  disabled,
}: SelectedFieldProps): React.JSX.Element {
  let SelectedOptions;

  if (mode === SelectType.SINGLE) {
    SelectedOptions = selectValues.map((item) => (
      <span className="selected-item" key={item}>
        {
          list.find((listItem) => listItem.value.toString() === item.toString())
            ?.name
        }
      </span>
    ));
  }

  if (mode === SelectType.MULTIPLE) {
    SelectedOptions = selectValues.map((item) => (
      <FilterTag
        key={item}
        type="default"
        size={size}
        title={
          list.find((listItem) => listItem.value.toString() === item.toString())
            ?.name as string
        }
        onClick={!disabled && removeItem ? () => removeItem(item) : undefined}
      />
    ));
  }

  return (
    <div
      className={`${styles.selectedRow} ${
        mode === SelectType.SINGLE ? styles.single : styles.multiple
      }`}
    >
      <div className={styles.row}>{SelectedOptions}</div>
    </div>
  );
}
